import { useNavigate, useSearchParams } from 'react-router-dom'
import { useVenues } from '../../hooks/useVenues'
import { useInventorySystemProfileToVenues } from '../../hooks/useInventorySystemProfileToVenues'
import { VenuesTable } from '../../components/VenuesTable/VenuesTable'
import { ListFilterBar } from '../../components/ListFilterBar/ListFilterBar'
import { ListEntityPage } from '../ListEntityPage/ListEntityPage'
import { buildListFiltersSearchParams } from '../helpers/buildListFiltersSearchParams'
import { matchesVenueFilters } from '../helpers/matchesVenueFilters'
import { readListFiltersFromParams } from '../helpers/readListFiltersFromParams'
import { VENUES_FILTER_FIELDS } from '../venueListFilterFields'
import { filterUnlinkedVenues } from './helpers/filterUnlinkedVenues'

export function UnlinkedVenuesPage() {
  const { venues, isLoading: venuesLoading, error: venuesError } = useVenues()
  const {
    mappings,
    isLoading: mappingsLoading,
    error: mappingsError,
  } = useInventorySystemProfileToVenues()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const filters = readListFiltersFromParams(searchParams, VENUES_FILTER_FIELDS)
  const unlinkedVenues = filterUnlinkedVenues(venues, mappings).filter(
    (venue) =>
      matchesVenueFilters(
        venue.id,
        venue,
        filters.venue ?? '',
        filters.venueType ?? ''
      )
  )

  return (
    <ListEntityPage
      title="Unlinked venues"
      description="Venues that are not linked to any inventory system profile. Select a venue to link it."
      loadingLabel="unlinked venues"
      isLoading={venuesLoading || mappingsLoading}
      error={venuesError ?? mappingsError}
    >
      <ListFilterBar
        fields={VENUES_FILTER_FIELDS}
        initialValues={filters}
        onChange={(next) =>
          setSearchParams(
            buildListFiltersSearchParams(
              searchParams,
              VENUES_FILTER_FIELDS,
              next
            )
          )
        }
      />
      <VenuesTable
        venues={unlinkedVenues}
        onRowClick={(venue) =>
          navigate(
            `/isp-to-venues/create?${new URLSearchParams({ venueId: venue.id }).toString()}`
          )
        }
      />
    </ListEntityPage>
  )
}
